export type UserProfile = {
	ActiveProcessUlid: string | null;
	ActiveProcessType: string | null;
	Active: boolean;
	FirstName: string;
	LastName: string;
	FullName: string | null;
	Address: string;
	Nationality: string;
	DocumentDateOfExpiration: string;
	PhoneCountryCode: string;
	PhoneNumber: string;
	BirthDate: string;
	NIT: string | null;
	DocumentIssuingCountry: string;
	UserId: string;
	DocumentNumber: string;
	DocumentType: string;
	Email: string;
	// Path 2 (public retrieval), computed server-side from the sponsor's
	// custom-bucket flag. The one snake_case field on this endpoint, and
	// optional while the backend rolls it out; read it through
	// readPublicRetrievalAllowed rather than reaching in directly.
	public_retrieval_allowed?: boolean;
};

// Returns null when the profile says nothing — an older backend, or no profile
// loaded yet — which callers treat as "unknown", not as "not allowed".
export function readPublicRetrievalAllowed(
	userProfile: UserProfile | null,
): boolean | null {
	if (typeof userProfile?.public_retrieval_allowed !== 'boolean') {
		return null;
	}
	return userProfile.public_retrieval_allowed;
}

export function isUserProfile(
	userProfile: unknown,
): userProfile is UserProfile {
	if (typeof userProfile !== 'object' || userProfile === null) {
		return false;
	}

	const profile = userProfile as Record<string, unknown>;

	return (
		(profile.ActiveProcessUlid === null ||
			typeof profile.ActiveProcessUlid === 'string') &&
		(profile.ActiveProcessType === null ||
			typeof profile.ActiveProcessType === 'string') &&
		typeof profile.Active === 'boolean' &&
		typeof profile.FirstName === 'string' &&
		typeof profile.LastName === 'string' &&
		(profile.FullName === null || typeof profile.FullName === 'string') &&
		typeof profile.Address === 'string' &&
		typeof profile.Nationality === 'string' &&
		typeof profile.DocumentDateOfExpiration === 'string' &&
		typeof profile.PhoneCountryCode === 'string' &&
		typeof profile.PhoneNumber === 'string' &&
		typeof profile.BirthDate === 'string' &&
		(profile.NIT === null || typeof profile.NIT === 'string') &&
		typeof profile.DocumentIssuingCountry === 'string' &&
		typeof profile.UserId === 'string' &&
		typeof profile.DocumentNumber === 'string' &&
		typeof profile.DocumentType === 'string' &&
		typeof profile.Email === 'string'
	);
}
